import { useEffect, useRef, useState } from "react";
import "./index.scss";
import ChromaKeyVideo from "../ChromaKeyVideo";
import { ClipLoader } from "react-spinners";

const HospitalIntro = ({ source, avatar, setSubmittedName, setFirstVisit, isSubmitLoading, setSubmitloading, language, handleSendMessage, idleURL }) => {
  const [currentScene, setCurrentScene] = useState(0);
  const [currentSceneVideo, setCurrentSceneVideo] = useState(0);
  const [userName, setUserName] = useState("");
  const videoRef = useRef(null);
  const nextVideoRef = useRef(null);
  const [isVideoShow, setVideoShow] = useState(true);
  const [isAnotherVideoShow, setAnotherVideoShow] = useState(false);

  const messages = [
    {
      message: `Hi, welcome to our hospital’s virtual assistant service. I'm Nurse ${avatar}.`,
      message_id: `Halo, selamat datang di layanan virtual asisten kami. Saya adalah Perawat ${avatar}.`,
      showSkip: true,
      showNameInput: false,
      isLoop: false,
      duration: 7000,
    },
    {
      message: "How are you feeling today?",
      message_id: "Bagaimana kondisi Anda hari ini?",
      showSkip: true,
      showNameInput: false,
      isLoop: false,
      duration: 5000,
    },
    {
      message: "Let me know if you need information about your medications or tips!",
      message_id: "Beri tahu saya jika Anda membutuhkan informasi tentang obat atau membutuhkan saran!",
      showSkip: true,
      showNameInput: false,
      isLoop: false,
      duration: 6000,
    },
    {
      message: "Hi, how can I address you?",
      message_id: "Halo, bagaimana saya dapat memanggil Anda?",
      showSkip: false,
      showNameInput: true,
      isLoop: false,
      duration: 5000,
    },
  ];

  const videos = [
    {
      video: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_welcome_en.mp4`,
      nextVideo: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_how_en.mp4`,
      video_id: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_welcome_id.mp4`,
      nextVideo_id: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_how_id.mp4`,
    },
    {
      video: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_lmk_en.mp4`,
      nextVideo: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_how_en.mp4`,
      video_id: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_lmk_id.mp4`,
      nextVideo_id: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_how_id.mp4`,
    },
    {
      video: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_lmk_en.mp4`,
      nextVideo: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_hi_en.mp4`,
      video_id: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_lmk_id.mp4`,
      nextVideo_id: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_hi_id.mp4`,
    },
    {
      video: idleURL,
      nextVideo: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_hi_en.mp4`,
      video_id: idleURL,
      nextVideo_id: `${process.env.PUBLIC_URL}/assets/video-avatar/${avatar}_hi_id.mp4`,
    },
  ];

  const { message, message_id, showSkip, showNameInput, isLoop, duration } = messages[currentScene] || messages[3];
  const { video, nextVideo, video_id, nextVideo_id } = videos[currentSceneVideo] || { video: idleURL, nextVideo: idleURL, video_id: idleURL, nextVideo_id: idleURL };

  const handleSubmitName = (e) => {
    e.preventDefault();
    setSubmitloading(true);
    localStorage.setItem('username', userName);
    setSubmittedName(userName);
    handleSendMessage(language === "english" ? `Hi, my name is ${userName}` : `Halo, nama saya ${userName}`);
    setFirstVisit(false);
  };

  const handleSkip = () => {
    const storedName = localStorage.getItem("username") || "You";
    setSubmittedName(storedName);
    handleSendMessage(language === "english" ? `Hi, my name is ${storedName}` : `Halo, nama saya ${storedName}`);
    setFirstVisit(false);
  };

  const preloadVideos = () => {
    const videoSources = videos.flatMap(video => [
      video.video,
      video.nextVideo,
      video.video_id,
      video.nextVideo_id
    ]);

    videoSources.forEach(src => {
      const videoElement = document.createElement('video');
      videoElement.src = src;
      videoElement.load();
    });
  };

  useEffect(() => {
    preloadVideos();
  }, []);

  useEffect(() => {
    if (currentScene === 0) videoRef.current.play();

    const timeout = setTimeout(() => {
      setCurrentSceneVideo((prev) => prev + 1);
      setVideoShow((prev) => !prev);
      setAnotherVideoShow((prev) => !prev);
      setCurrentScene((prev) => prev + 1);
      (isVideoShow ? nextVideoRef : videoRef).current?.play();
    }, duration);

    return () => clearTimeout(timeout);
  }, [currentScene, duration, isVideoShow]);

  return (
    <div className="intro">
      <video
        className={`chroma-video ${isVideoShow ? 'show' : 'hide'}`}
        ref={videoRef}
        src={language === "english" ? video : video_id}
        loop={isLoop}
        autoPlay={false}
        avatar={avatar}
        playsInline={true}
      />
      <video
        className={`chroma-video ${isAnotherVideoShow ? 'show' : 'hide'}`}
        ref={nextVideoRef}
        src={language === "english" ? nextVideo : nextVideo_id}
        loop={isLoop}
        autoPlay={false}
        avatar={avatar}
        playsInline={true}
      />
      <div className="homepage__intro-popup hospital">
        <div className={`homepage__intro-popup--container ${source}`}>
          <img className="bg-popup--message" src={`${process.env.PUBLIC_URL}/assets/hospital_dialog.png`} alt="" />
          <p className="popup-message">{language === "english" ? message : message_id}</p>
          {showNameInput && (
            <form className="hospital-input-name" onSubmit={handleSubmitName}>
              <input
                type="text"
                placeholder={language === "english" ? "Enter your name" : "Ketik namamu di sini"}
                value={userName}
                pattern="[A-Za-z\s]*"
                maxLength="20"
                title="Only letters and space are allowed"
                onChange={(e) => setUserName(e.target.value)}
                required
              />
              <button type="submit">
                {isSubmitLoading ? <ClipLoader color="#fff" size={16} /> : <img src={`${process.env.PUBLIC_URL}/assets/hospital_submit.svg`} alt="Submit" />}
              </button>
            </form>
          )}
          {showSkip && (
            <div className="hospital-popup__skip-button" onClick={handleSkip}>
              {language === "english" ? "skip" : "lewati"}
              <img src={`${process.env.PUBLIC_URL}/assets/hospital_skip_icon.svg`} alt="Skip" />
            </div>
          )}
        </div>
      </div>
      <div className="intro-overlay"></div>
    </div>
  );
};

export default HospitalIntro;
